<template>
    <div>
        <ul>
            <router-link class="" :to="'/managers/users'" tag="li"><a>Пользователи</a></router-link>
            <router-link class="" :to="'/managers/settings'" tag="li"><a>Settings</a></router-link>
        </ul>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/manager/Menu.vue